import { Logger } from "../logger/browserLogger";

/*
* Submits lead data to Salesforce via a proxy API.
* 
* @param salesForceProxyApiUrl - The URL of the Salesforce proxy API.
* @param userAccessToken - The user's access token containing email and other details.
* @param formId - Optional form ID to include in the payload.
* @param sfdcCampaignId - Optional Salesforce campaign ID to include in the payload.
* @param logger - Logger instance for error reporting.
*/

export const submitToSalesForce = async (
  salesForceProxyApiUrl: string, 
  userAccessToken: any, 
  formId: string | null, 
  sfdcCampaignId: string | null,
  logger: Logger
) => {
  const data: any = {
    Email: userAccessToken?.email,
    FirstName: userAccessToken?.firstName, // NOTE: do NOT put "fallback" values here. SFDC API will handle that on their end even if name is empty/null/undefined.
    ExtranetId: userAccessToken?.extranetId,
    CurrentUrl: document.location.href,
    ReferringUrl: document.referrer,
  };

  // Only add formId and sfdcCampaignId to payload when they are available
  if (formId) {
    data.FormId = formId;
  }
  
  if (sfdcCampaignId) {
    data.CampaignID = sfdcCampaignId;
  }

  try {
    const response = await fetch(`${salesForceProxyApiUrl}/leadcreationservice`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // handle success
  } catch (error) {
    // Log Salesforce submission errors via the client-side logger for observability
    logger.warn('SF submission ERROR', { error: error instanceof Error ? error.message : String(error) });
  }
};
